module.exports = __webpack_public_path__ + "img/t3-c6.9dc6c2bc.png";